import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import BookingModal from './BookingModal';
import AuthModals from './AuthModals';
import '../styles/LocationServices.css';

const LocationServices: React.FC = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showBooking, setShowBooking] = useState(false);

  return (
    <div className="location-page">
      <Header 
        onOpenLogin={() => setShowLogin(true)}
        onOpenSignup={() => setShowSignup(true)}
      />
      
      <section className="location-banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Legal Services in Delhi NCR</h1>
          <p className="banner-subtitle">
            Professional legal consultation services across Delhi, Gurgaon, Noida, and Faridabad with doorstep convenience.
          </p>
          <div className="banner-icons">
            <div className="banner-icon">
              <i className="fas fa-map-marker-alt"></i>
              <span>Local</span>
            </div>
            <div className="banner-icon">
              <i className="fas fa-home"></i>
              <span>Doorstep</span>
            </div>
            <div className="banner-icon">
              <i className="fas fa-clock"></i>
              <span>24/7</span>
            </div>
          </div>
        </div>
      </section>

      <div className="location-container">
        <div className="location-content">
          <section className="cities-section">
            <h2>Cities We Serve</h2>
            <div className="cities-grid">
              <div className="city-card">
                <i className="fas fa-building"></i>
                <h3>Delhi</h3>
                <p>Legal services across all districts of Delhi including Central Delhi, North Delhi, South Delhi, East Delhi, and West Delhi.</p>
                <ul>
                  <li>High Court matters</li>
                  <li>District court cases</li>
                  <li>Consumer court disputes</li>
                  <li>Property registration</li>
                </ul>
                <button className="city-btn" onClick={() => setShowBooking(true)}>Book in Delhi</button>
              </div>

              <div className="city-card">
                <i className="fas fa-city"></i>
                <h3>Gurgaon</h3>
                <p>Comprehensive legal services in Gurgaon covering corporate law, property disputes, and civil matters.</p>
                <ul>
                  <li>Corporate legal services</li>
                  <li>Real estate matters</li>
                  <li>Employment disputes</li>
                  <li>Contract negotiations</li>
                </ul>
                <button className="city-btn" onClick={() => setShowBooking(true)}>Book in Gurgaon</button>
              </div>

              <div className="city-card">
                <i className="fas fa-landmark"></i>
                <h3>Noida</h3>
                <p>Professional legal consultation services in Noida and Greater Noida for individuals and businesses.</p>
                <ul>
                  <li>Property verification</li>
                  <li>Business registrations</li>
                  <li>Civil litigation</li>
                  <li>Family law matters</li>
                </ul>
                <button className="city-btn" onClick={() => setShowBooking(true)}>Book in Noida</button>
              </div>

              <div className="city-card">
                <i className="fas fa-university"></i>
                <h3>Faridabad</h3>
                <p>Expert legal services in Faridabad covering all major practice areas with local court representation.</p>
                <ul>
                  <li>Criminal defense</li>
                  <li>Civil suits</li>
                  <li>Property matters</li>
                  <li>Consumer complaints</li>
                </ul>
                <button className="city-btn" onClick={() => setShowBooking(true)}>Book in Faridabad</button>
              </div>
            </div>
          </section>

          <section className="coverage-section">
            <h2>Service Coverage Areas</h2>
            <div className="coverage-grid">
              <div className="coverage-item">
                <h3>Delhi High Court</h3>
                <p>Expert representation in Delhi High Court for civil, criminal, and constitutional matters.</p>
              </div>
              <div className="coverage-item">
                <h3>District Courts</h3>
                <p>Comprehensive coverage across all district courts in Delhi NCR region.</p>
              </div>
              <div className="coverage-item">
                <h3>Consumer Forums</h3>
                <p>Consumer dispute resolution at district, state, and national consumer forums.</p>
              </div>
              <div className="coverage-item">
                <h3>Tribunals</h3>
                <p>Specialized tribunal matters including labour, service, and tax tribunals.</p>
              </div>
            </div>
          </section>

          <section className="local-expertise">
            <h2>Local Legal Expertise</h2>
            <div className="expertise-content">
              <div className="expertise-text">
                <h3>Why Choose Local Lawyers?</h3>
                <ul>
                  <li><strong>Local Court Knowledge:</strong> Familiar with local court procedures and judges</li>
                  <li><strong>Regional Law Expertise:</strong> Understanding of state-specific laws and regulations</li>
                  <li><strong>Quick Response:</strong> Immediate availability for urgent legal matters</li>
                  <li><strong>Cost Effective:</strong> No travel expenses, transparent flat-rate pricing</li>
                  <li><strong>Personal Touch:</strong> Face-to-face consultation at your convenience</li>
                </ul>
              </div>
              <div className="expertise-stats">
                <div className="stat-item">
                  <span className="stat-number">15+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Cases Handled</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">95%</span>
                  <span className="stat-label">Success Rate</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
      
      <BookingModal 
        isOpen={showBooking}
        onClose={() => setShowBooking(false)}
      />
      <AuthModals 
        showLogin={showLogin}
        showSignup={showSignup}
        onCloseLogin={() => setShowLogin(false)}
        onCloseSignup={() => setShowSignup(false)}
        onOpenSignup={() => setShowSignup(true)}
        onOpenLogin={() => setShowLogin(true)}
      />
    </div>
  );
};

export default LocationServices;